module.exports = __webpack_public_path__ + "img/ico-9.3873d392.svg";